var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView',{key:_vm.$route.fullPath}),_c('notifications',{attrs:{"group":"foo","classes":"custom-vue-notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }